import { render, staticRenderFns } from "./searchNews.vue?vue&type=template&id=e65dbf1e&scoped=true&"
import script from "./searchNews.vue?vue&type=script&lang=js&"
export * from "./searchNews.vue?vue&type=script&lang=js&"
import style0 from "./searchNews.vue?vue&type=style&index=0&id=e65dbf1e&scoped=true&lang=css&"
import style1 from "./searchNews.vue?vue&type=style&index=1&id=e65dbf1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65dbf1e",
  null
  
)

export default component.exports